import ChartCard from "src/components/cards/ChartCard";
import Page from "src/components/layouts/Page";
import Grid from "src/components/layouts/Grid";
import ReportCard from "src/components/cards/ReportCard";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import colors from "../styles/jscolors.module.scss";
import Zoom from "chartjs-plugin-zoom";

// import {
// 	Chart as ChartJS,
// 	CategoryScale,
// 	LinearScale,
// 	PointElement,
// 	LineElement,
// 	Title,
// 	Tooltip,
// 	Legend,
// 	ArcElement,
// 	BarElement,
// 	Filler,
// 	Chart,
// } from 'chart.js'

import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Filler,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// import { Charity } from "src/data/fake/charts/charity/";
// import { Comparisons } from "src/data/fake/charts/comparisons";
// import { Deliveries } from "src/data/fake/charts/deliveries";
// import { MostSold } from "src/data/fake/charts/mostSold";
// import { Orders } from "src/data/fake/charts/orders";
// import { Sales } from "src/data/fake/charts/sales";
import { useEffect, useState } from "react";
// import { getpen } from "src/actions/getpending";
import { useDispatch, useSelector } from "react-redux";
import { getStatistics } from "src/slices/info";
import EmptyPage from "src/components/molecules/EmptyPage";

// import {
//   salesByPeriod,
//   hits,
//   charity,
//   deliveries,
//   customers,
// } from "src/data/fake/fakeCharts";
// import { getStat } from 'src/actions/statics'
// import Button from "src/components/atoms/Button";
import css from "./Analytics.module.scss";
// import { Link } from "react-router-dom";

// ChartJS.register(
// 	CategoryScale,
// 	LinearScale,
// 	PointElement,
// 	LineElement,
// 	Title,
// 	ArcElement,
// 	Tooltip,
// 	Legend,
// 	Filler,
// 	BarElement
// )

ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
    Filler,
    Zoom
);

const options = {
    // responsive: true,
    aspectRatio: 1,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: "bottom",
            labels: {
                font: {
                    family: "poppins",
                },
            },
        },
        // title: {
        //    display: true,
        //    text: "Chart.js Line Chart",
        // },
    },
};

const pieOptions = {
    legend: {
        display: false,
        position: "right",
    },
    elements: {
        arc: {
            borderWidth: 0,
        },
    },
};
const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Added by Shahriar. Fix it.=======

const rangeOptions = [
    { label: "30 Days", value: 30 },
    { label: "15 Days", value: 15 },
    { label: "10 Days", value: 10 },
    { label: "5 Days", value: 5 },
    { label: "Last Day", value: 1 },
];

// ==================================

export default function Analytics() {
    const [range, setRange] = useState(rangeOptions[0]); // added by shahriar

    const dispatch = useDispatch();
    const { permissions } = useSelector((state) => state.auth);

    // sales=365&hits=1&customers=15&deliveries&revenue=&charity=&orders=
    const [params, setParams] = useState({
        sales: 365,
        hits: 365,
        customers: 30,
        // deliveries: 30,
        revenue: 30,
        charity: 30,
        orders: 30,
    });

    useEffect(() => {
        dispatch(getStatistics(params));
    }, [params]);
    const { statistics } = useSelector((state) => state.info);

    const salesData = {
        labels,
        datasets: [
            {
                label: "Monthly Sales",
                data: statistics.salesByPeriod?.val,
                // borderColor: '#10b981',
                backgroundColor: ["#34d399", "#6ee7b7"],
                color: "",
            },
        ],
    };
    const userData = {
        labels,
        datasets: [
            {
                label: "Monthly Sales and Store Views",
                data: statistics.hits?.val,
                borderColor: "#34d399",
                // backgroundColor: '#51D9C1',
                fill: {
                    target: "origin",
                    above: "#6ee7b740",
                },
            },
        ],
    };

    const data = {
        labels,
        datasets: [
            {
                type: "line",
                // label: 'Dataset 2',
                // backgroundColor: 'rgb(75, 192, 192)',
                // data: statistics.hits?.val,
                // borderColor: 'white',
                // borderWidth: 2,
                label: "Store Views",
                data: statistics.hits?.val,
                borderColor: colors["blue-500"],
                backgroundColor: colors["blue-500"],
                // // fill: {
                // target: 'origin',
                // above: '#ba25ce',
                // // },

                fill: {
                    target: "origin",
                    above: colors["blue-50"],
                },
                // plugins: ['filler'],
                cubicInterpolationMode: "monotone",
                tension: 0.4,
                // options: {
                // 	plugins: {
                // 		zoom: {
                // 			zoom: {
                // 				wheel: {
                // 					enabled: true,
                // 				},
                // 				pinch: {
                // 					enabled: true,
                // 				},
                // 				mode: 'xy',
                // 			},
                // 		},
                // 	},
                // },
            },
            {
                type: "bar",
                // label: 'Dataset 1',
                // borderColor: 'rgb(255, 99, 132, 70)',
                borderWidth: 2,
                // fill: false,
                // data: statistics.salesByPeriod?.val,

                label: "Monthly Sales (USD)",
                data: statistics.salesByPeriod?.val,
                borderColor: "rgb(16,185,129, .85)",
                backgroundColor: ["rgb(52,211,153, .7)", "rb(110,231,183, .7)"],
                color: "",
                // options: {
                // 	plugins: {
                // 		zoom: {
                // 			zoom: {
                // 				wheel: {
                // 					enabled: true,
                // 				},
                // 				pinch: {
                // 					enabled: true,
                // 				},
                // 				mode: 'xy',
                // 			},
                // 		},
                // 	},
                // },
            },
        ],
    };

    // const mixedChart = new Chart(ctx, {
    // 	data: {
    // 		datasets: [
    // 			{
    // 				label: 'Sales by Period',
    // 				data: statistics.salesByPeriod?.val,
    // 				// borderColor: '#10b981',
    // 				backgroundColor: ['#34d399', '#6ee7b7'],
    // 				color: '',
    // 			},
    // 			{
    // 				label: 'Store Views',
    // 				data: statistics.hits?.val,
    // 				borderColor: '#34d399',
    // 				// backgroundColor: '#51D9C1',
    // 				fill: {
    // 					target: 'origin',
    // 					above: '#6ee7b740',
    // 				},
    // 			},
    // 		],
    // 		labels: ['January', 'February', 'March', 'April'],
    // 	},
    // 	options: options,
    // })

    // const optionsSales = {
    //     responsive: true,
    //     plugins: {
    //       legend: {
    //         position: 'top',
    //       },
    //       title: {
    //         display: true,
    //         text: 'Chart.js Bar Chart',
    //       },
    //     },
    // }

    const handleRange = (selected) => {
        const number = selected.target.value;
        setRange(number);

        setParams({
            ...params,
            revenue: number,
            orders: number,
            customers: number,
            charity: number,
        });

        // bring me back
    };
    return (
        <Page>
            {permissions.read.includes("analytics") ? (
                <>
                    <Grid style={{ marginBottom: "24px" }}>
                        <ReportCard
                            smallIcon="dollar-sign"
                            title="Revenue"
                            valuePrev={statistics.revenue?.prev?.val}
                            valueNow={statistics?.revenue?.val}
                            change={statistics?.revenue?.change}
                            dates={statistics?.revenue?.dates}
                            type="dollar"
                            handleDropdown={(number) => setParams({ ...params, revenue: number })}
                        />
                        <ReportCard
                            smallIcon="receipt"
                            title="Orders"
                            valuePrev={statistics?.orders?.prev?.val}
                            valueNow={statistics?.orders?.val}
                            change={statistics?.orders?.change}
                            dates={statistics?.orders?.dates}
                            handleDropdown={(number) => setParams({ ...params, orders: number })}
                        />
                        {/* <ReportCard
                    title="Deliveries"
                    valuePrev=""
                    valueNow={0}
                    timeFrame="Yesterday"
                /> */}
                        <ReportCard
                            smallIcon="users"
                            title="Customers"
                            valuePrev={statistics?.customers?.prev?.val}
                            valueNow={statistics?.customers?.val}
                            change={statistics?.customers?.change}
                            dates={statistics?.customers?.dates}
                            handleDropdown={(number) => setParams({ ...params, customers: number })}
                        />
                        {/*<ReportCard
          title="Successful Orders"
          valuePrev={96}
          valueNow={99}
          type="percent"
        /> */}
                        <ReportCard
                            smallIcon="hand-holding-heart"
                            title="Charity"
                            valuePrev={statistics?.charity?.prev?.val}
                            valueNow={statistics?.charity?.val}
                            change={statistics?.charity?.change}
                            dates={statistics?.charity?.dates}
                            handleDropdown={(number) => setParams({ ...params, charity: number })}
                            type="dollar"
                        />
                    </Grid>
                    <Grid
                        style={{
                            marginBottom: "24px",
                            // gridTemplateColumns: "repeat(auto-fit, minmax(224px, 1fr))",
                        }}
                    >
                        {/* <ChartCard
							w={1}
							title='Sales'>
							<Bar
								options={options}
								data={salesData}
							/> */}

                        {/* <Line options={options} data={salesData} /> */}
                        {/* </ChartCard> */}

                        <ChartCard
                        // w={1}
                        >
                            {/* <Line
								options={options}
								data={userData}
							/> */}
                            <Chart type="bar" data={data} />
                        </ChartCard>

                        {/* <ChartCard w={1}>
               <Pie options={pieOptions} data={deliveries} />
            </ChartCard> */}
                    </Grid>

                    <select className={css["select"]} value={range} onChange={handleRange}>
                        {rangeOptions.map((option) => (
                            <option className={css["option"]} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>

                    {/* <h2 className={css["title"]} style={{marginTop: "24px", marginBottom: "24px" }}>Analytics</h2> */}
                </>
            ) : (
                <EmptyPage
                    title="You don’t have permission to view anything on this page"
                    text="Ask your employer for access"
                    iconName="fad fa-lock"
                />
            )}
        </Page>
    );
}
